// import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
// import { SERVER_ROUTE } from '../../routes/api/api_routes';

// const coachApi = createApi({
//     reducerPath: 'coachApi',
//     baseQuery: fetchBaseQuery({
//         baseUrl: `${SERVER_ROUTE}/api/v1/`,
//         prepareHeaders: (headers, { getState }) => {
//             const token = localStorage.getItem('access'); // Assuming token is stored in localStorage
//             if (token) {
//                 headers.set('Authorization', `JWT ${token}`);
//             }
//             headers.set('Content-Type', 'application/json');
//             headers.set('Accept', 'application/json');
//             return headers;
//         },
//     }),
//     tagTypes: ['Domaine', 'Technology', 'Niveau', 'Category', 'Exercise', 'Question', 'Quizz'],
//     endpoints: (builder) => ({
//         // Domaines
//         getDomaines: builder.query({
//             query: () => 'domaine/',
//             providesTags: ['Domaine'],
//             transformResponse: (response) => response.data, // Adjust based on your API response structure
//         }),
//         addDomaine: builder.mutation({
//             query: (newDomaine) => ({
//                 url: 'domaine/',
//                 method: 'POST',
//                 body: newDomaine,
//             }),
//             invalidatesTags: ['Domaine'],
//         }),
//         updateDomaine: builder.mutation({
//             query: ({ id, ...rest }) => ({
//                 url: `domaine/${id}/`,
//                 method: 'PUT',
//                 body: rest,
//             }),
//             invalidatesTags: ['Domaine'],
//         }),
//         deleteDomaine: builder.mutation({
//             query: (id) => ({
//                 url: `domaine/${id}/`,
//                 method: 'DELETE',
//             }),
//             invalidatesTags: ['Domaine'],
//         }),

//         // Technologies
//         getTechnologies: builder.query({
//             query: () => 'technology/',
//             providesTags: ['Technology'],
//             transformResponse: (response) => response.data,
//         }),
//         addTechnology: builder.mutation({
//             query: (newTechnology) => ({
//                 url: 'technology/',
//                 method: 'POST',
//                 body: newTechnology,
//             }),
//             invalidatesTags: ['Technology'],
//         }),
//         updateTechnology: builder.mutation({
//             query: ({ id, ...rest }) => ({
//                 url: `technology/${id}/`,
//                 method: 'PUT',
//                 body: rest,
//             }),
//             invalidatesTags: ['Technology'],
//         }),
//         deleteTechnology: builder.mutation({
//             query: (id) => ({
//                 url: `technology/${id}/`,
//                 method: 'DELETE',
//             }),
//             invalidatesTags: ['Technology'],
//         }),

//         // Niveaux
//         getNiveaux: builder.query({
//             query: () => 'niveau/',
//             providesTags: ['Niveau'],
//             transformResponse: (response) => response.data,
//         }),
//         addNiveau: builder.mutation({
//             query: (newNiveau) => ({
//                 url: 'niveau/',
//                 method: 'POST',
//                 body: newNiveau,
//             }),
//             invalidatesTags: ['Niveau'],
//         }),
//         updateNiveau: builder.mutation({
//             query: ({ id, ...rest }) => ({
//                 url: `niveau/${id}/`,
//                 method: 'PUT',
//                 body: rest,
//             }),
//             invalidatesTags: ['Niveau'],
//         }),
//         deleteNiveau: builder.mutation({
//             query: (id) => ({
//                 url: `niveau/${id}/`,
//                 method: 'DELETE',
//             }),
//             invalidatesTags: ['Niveau'],
//         }),

//         // Categories
//         getCategories: builder.query({
//             query: () => 'category/',
//             providesTags: ['Category'],
//             transformResponse: (response) => response.data,
//         }),
//         addCategory: builder.mutation({
//             query: (newCategory) => ({
//                 url: 'category/',
//                 method: 'POST',
//                 body: newCategory,
//             }),
//             invalidatesTags: ['Category'],
//         }),
//         updateCategory: builder.mutation({
//             query: ({ id, ...rest }) => ({
//                 url: `category/${id}/`,
//                 method: 'PUT',
//                 body: rest,
//             }),
//             invalidatesTags: ['Category'],
//         }),
//         deleteCategory: builder.mutation({
//             query: (id) => ({
//                 url: `category/${id}/`,
//                 method: 'DELETE',
//             }),
//             invalidatesTags: ['Category'],
//         }),

//         // Exercises
//         getExercises: builder.query({
//             query: () => 'exercice/',
//             providesTags: ['Exercise'],
//             transformResponse: (response) => response.data,
//         }),
//         addExercise: builder.mutation({
//             query: (newExercise) => ({
//                 url: 'exercice/',
//                 method: 'POST',
//                 body: newExercise,
//             }),
//             invalidatesTags: ['Exercise'],
//         }),
//         updateExercise: builder.mutation({
//             query: ({ id, ...rest }) => ({
//                 url: `exercice/${id}/`,
//                 method: 'PUT',
//                 body: rest,
//             }),
//             invalidatesTags: ['Exercise'],
//         }),
//         deleteExercise: builder.mutation({
//             query: (id) => ({
//                 url: `exercice/${id}/`,
//                 method: 'DELETE',
//             }),
//             invalidatesTags: ['Exercise'],
//         }),

//         // Questions
//         getQuestions: builder.query({
//             query: () => 'question/',
//             providesTags: ['Question'],
//             transformResponse: (response) => response.data,
//         }),
//         addQuestion: builder.mutation({
//             query: (newQuestion) => ({
//                 url: 'question/',
//                 method: 'POST',
//                 body: newQuestion,
//             }),
//             invalidatesTags: ['Question'],
//         }),
//         updateQuestion: builder.mutation({
//             query: ({ id, ...rest }) => ({
//                 url: `question/${id}/`,
//                 method: 'PUT',
//                 body: rest,
//             }),
//             invalidatesTags: ['Question'],
//         }),
//         deleteQuestion: builder.mutation({
//             query: (id) => ({
//                 url: `question/${id}/`,
//                 method: 'DELETE',
//             }),
//             invalidatesTags: ['Question'],
//         }),

//         // Quizzes
//         getQuizzes: builder.query({
//             query: () => 'quizzprofile/',
//             providesTags: ['Quizz'],
//             transformResponse: (response) => response.data,
//         }),
//         addQuiz: builder.mutation({
//             query: (newQuiz) => ({
//                 url: 'quizzprofile/',
//                 method: 'POST',
//                 body: newQuiz,
//             }),
//             invalidatesTags: ['Quizz'],
//         }),
//         updateQuiz: builder.mutation({
//             query: ({ id, ...rest }) => ({
//                 url: `quizzprofile/${id}/`,
//                 method: 'PUT',
//                 body: rest,
//             }),
//             invalidatesTags: ['Quizz'],
//         }),
//         deleteQuiz: builder.mutation({
//             query: (id) => ({
//                 url: `quizzprofile/${id}/`,
//                 method: 'DELETE',
//             }),
//             invalidatesTags: ['Quizz'],
//         }),

//         // Récupérer la liste des utilisateurs
//        getUsers: builder.query({
//           query: () => 'users/',
//              providesTags: ['User'],
//        }),

//   // Changer le rôle d'un utilisateur
//       changeUserRole: builder.mutation({
//          query: ({ userId, role }) => ({
//             url: `users/${userId}/change-role/`,
//             method: 'POST',
//             body: { role },
//       }),
//     invalidatesTags: ['User'],
//   }),

//     }),
// });

// export const {
//     useGetDomainesQuery,
//     useAddDomaineMutation,
//     useUpdateDomaineMutation,
//     useDeleteDomaineMutation,
//     useGetTechnologiesQuery,
//     useAddTechnologyMutation,
//     useUpdateTechnologyMutation,
//     useDeleteTechnologyMutation,
//     useGetNiveauxQuery,
//     useAddNiveauMutation,
//     useUpdateNiveauMutation,
//     useDeleteNiveauMutation,
//     useGetCategoriesQuery,
//     useAddCategoryMutation,
//     useUpdateCategoryMutation,
//     useDeleteCategoryMutation,
//     useGetExercisesQuery,
//     useAddExerciseMutation,
//     useUpdateExerciseMutation,
//     useDeleteExerciseMutation,
//     useGetQuestionsQuery,
//     useAddQuestionMutation,
//     useUpdateQuestionMutation,
//     useDeleteQuestionMutation,
//     useGetQuizzesQuery,
//     useAddQuizMutation,
//     useUpdateQuizMutation,
//     useDeleteQuizMutation,
//     useChangeUserRoleMutation,
//     useGetUsersQuery,
// } = coachApi;

// export default coachApi;
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { SERVER_ROUTE } from "../../routes/api/api_routes";

const coachApi = createApi({
  reducerPath: "coachApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${SERVER_ROUTE}/api/v1/`,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("access"); // Assuming token is stored in localStorage
      if (token) {
        headers.set("Authorization", `JWT ${token}`);
      }
      headers.set("Content-Type", "application/json");
      headers.set("Accept", "application/json");
      return headers;
    },
  }),
  tagTypes: [
    "Domaine",
    "Parcours",
    "Technology",
    "Niveau",
    "Category",
    "Exercise",
    "Question",
    "Quizz",
    "Users",
  ],
  endpoints: (builder) => ({
    // Domaines
    getDomaines: builder.query({
      query: () => "domaine/",
      providesTags: ["Domaine"],
      transformResponse: (response) => response.data || response,
    }),
    addDomaine: builder.mutation({
      query: (newDomaine) => ({
        url: "domaine/",
        method: "POST",
        body: newDomaine,
      }),
      invalidatesTags: ["Domaine"],
    }),
    updateDomaine: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `domaine/${id}`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["Domaine"],
    }),
    deleteDomaine: builder.mutation({
      query: (id) => ({
        url: `domaine/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Domaine"],
    }),
     
    // Parcours
    getParcours: builder.query({
      query: () => "parcours/",
      providesTags: ["Parcours"],
      transformResponse: (response) => response.data || response,
    }),
    addParcours: builder.mutation({
      query: (newParcours) => ({
        url: "parcours/",
        method: "POST",
        body: newParcours,
      }),
      invalidatesTags: ["Parcours"],
    }),
    updateParcours: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `parcours/${id}`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["Parcours"],
    }),
    deleteParcours: builder.mutation({
      query: (id) => ({
        url: `parcours/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Parcours"],
    }),

    // Technologies
    getTechnologies: builder.query({
      query: () => "technology/",
      providesTags: ["Technology"],
      transformResponse: (response) => response.data || response,
    }),
    addTechnology: builder.mutation({
      query: (newTechnology) => ({
        url: "technology/",
        method: "POST",
        body: {
          name: newTechnology.name,
          description: newTechnology.description || "",
          category: parseInt(newTechnology.category),
          parcours: parseInt(newTechnology.parcours),
        },
      }),
      invalidatesTags: ["Technology"],
    }),
    updateTechnology: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `technology/${id}`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["Technology"],
    }),
    deleteTechnology: builder.mutation({
      query: (id) => ({
        url: `technology/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Technology"],
    }),

    // Niveaux
    getNiveaux: builder.query({
      query: () => "niveau/",
      providesTags: ["Niveau"],
      transformResponse: (response) => response.data || response,
    }),
    addNiveau: builder.mutation({
      query: (newNiveau) => ({
        url: "niveau/",
        method: "POST",
        body: newNiveau,
      }),
      invalidatesTags: ["Niveau"],
    }),
    updateNiveau: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `niveau/${id}`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["Niveau"],
    }),
    deleteNiveau: builder.mutation({
      query: (id) => ({
        url: `niveau/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["Niveau"],
    }),

    // Categories
    getCategories: builder.query({
      query: () => "category/",
      providesTags: ["Category"],
      transformResponse: (response) => response.data || response,
    }),
    addCategory: builder.mutation({
      query: (newCategory) => ({
        url: "category/",
        method: "POST",
        body: {
          nom: newCategory.nom,
          domaine: parseInt(newCategory.domaine),
          description: newCategory.description || "", // optionnel
        },
      }),
      invalidatesTags: ["Category"],
    }),
    updateCategory: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `category/${id}`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["Category"],
    }),
    deleteCategory: builder.mutation({
      query: (id) => ({
        url: `category/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Category"],
    }),

    // Exercises
    getExercises: builder.query({
      query: () => "exercice/",
      providesTags: ["Exercise"],
      transformResponse: (response) => response.data || response,
    }),
    addExercise: builder.mutation({
      query: (newExercise) => ({
        url: "exercice/",
        method: "POST",
        body: newExercise,
      }),
      invalidatesTags: ["Exercise"],
    }),
    updateExercise: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `exercice/${id}/`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["Exercise"],
    }),
    deleteExercise: builder.mutation({
      query: (id) => ({
        url: `exercice/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["Exercise"],
    }),

    // Questions
    getQuestions: builder.query({
      query: () => "question/",
      providesTags: ["Question"],
      transformResponse: (response) => response.data || response,
    }),
    addQuestion: builder.mutation({
      query: (newQuestion) => ({
        url: "question/",
        method: "POST",
        body: newQuestion,
      }),
      invalidatesTags: ["Question"],
    }),
    updateQuestion: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `question/${id}/`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["Question"],
    }),
    deleteQuestion: builder.mutation({
      query: (id) => ({
        url: `question/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["Question"],
    }),

    // Quizzes
    getQuizzes: builder.query({
      query: () => "quizzprofile/",
      providesTags: ["Quizz"],
      transformResponse: (response) => response.data || response,
    }),
    addQuiz: builder.mutation({
      query: (newQuiz) => ({
        url: "quizzprofile/",
        method: "POST",
        body: newQuiz,
      }),
      invalidatesTags: ["Quizz"],
    }),
    updateQuiz: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `quizzprofile/${id}/`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["Quizz"],
    }),
    deleteQuiz: builder.mutation({
      query: (id) => ({
        url: `quizzprofile/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["Quizz"],
    }),

    // Users Management
    getUsers: builder.query({
      query: () => "users/",
      providesTags: ["Users"],
      transformResponse: (response) => {
        // Gérer les différentes structures de réponse
        if (response.data) return response.data;
        if (Array.isArray(response)) return response;
        return response;
      },
    }),

    getUserById: builder.query({
      query: (id) => `users/${id}/`,
      providesTags: (result, error, id) => [{ type: "Users", id }],
    }),

    changeUserRole: builder.mutation({
      query: ({ userId, role }) => ({
        url: `users/${userId}/change-role/`,
        method: "PUT",
        body: { role },
      }),
      invalidatesTags: ["Users"],
      // Gestion d'erreur personnalisée
      async onQueryStarted({ userId, role }, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          console.log(`Rôle de l'utilisateur ${userId} changé vers ${role}`);
        } catch (error) {
          console.error("Erreur lors du changement de rôle:", error);
        }
      },
    }),

    // Login/Authentication
    login: builder.mutation({
      query: (credentials) => ({
        url: "login/",
        method: "POST",
        body: credentials,
      }),
    }),

    logout: builder.mutation({
      query: () => ({
        url: "logout/",
        method: "GET",
      }),
    }),

    // Password Reset
    passwordReset: builder.mutation({
      query: (email) => ({
        url: "password-reset/",
        method: "POST",
        body: { email },
      }),
    }),
  }),
});

export const {
  useGetDomainesQuery,
  useAddDomaineMutation,
  useUpdateDomaineMutation,
  useDeleteDomaineMutation,
  useGetTechnologiesQuery,
  useAddTechnologyMutation,
  useUpdateTechnologyMutation,
  useDeleteTechnologyMutation,
  useGetNiveauxQuery,
  useAddNiveauMutation,
  useUpdateNiveauMutation,
  useDeleteNiveauMutation,
  useGetCategoriesQuery,
  useAddCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
  useGetExercisesQuery,
  useAddExerciseMutation,
  useUpdateExerciseMutation,
  useDeleteExerciseMutation,
  useGetQuestionsQuery,
  useAddQuestionMutation,
  useUpdateQuestionMutation,
  useDeleteQuestionMutation,
  useGetQuizzesQuery,
  useAddQuizMutation,
  useUpdateQuizMutation,
  useDeleteQuizMutation,
  useGetUsersQuery,
  useGetUserByIdQuery,
  useChangeUserRoleMutation,
  useLoginMutation,
  useLogoutMutation,
  usePasswordResetMutation,
  useGetParcoursQuery,
  useAddParcoursMutation,
  useUpdateParcoursMutation,
  useDeleteParcoursMutation
} = coachApi;

export default coachApi;
